import { createReducer } from '@reduxjs/toolkit';

import type { IGiftModal, ICashItem, ICategoryItem } from './interfaces';
import * as actions from './actions';

const initialState: IGiftModal = {
  cash: {
    list: [],
    listMap: {},
    categories: [],
    meta: {
      amount: null,
      isLoading: false,
      isChanging: false,
    },
  },
  isOpen: false,
  isOpenUseLater: false,
  isOpenTerms: false,
  isLoading: false,
  hasError: false,
};

const sortByAlphabetical = (a: string, b: string) => {
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  return 0;
};

export default createReducer(initialState, (builder) => builder
  .addCase(actions.resetGift, (state) => {
    state.cash = {
      ...initialState.cash,
      meta: {
        ...initialState.cash.meta,
      },
    };
    state.isOpen = initialState.isOpen;
    state.isLoading = initialState.isLoading;
    state.hasError = initialState.hasError;
  })
  .addCase(actions.setLoadingGift, (state, action) => {
    state.isLoading = action.payload.isLoading;
  })
  .addCase(actions.setGiftError, (state, action) => {
    state.hasError = action.payload.hasError;
  })
  .addCase(actions.setOpenUseLater, (state, action) => {
    state.isOpenUseLater = action.payload.isOpen;
  })
  .addCase(actions.setOpenGiftTerms, (state, action) => {
    state.isOpenTerms = action.payload.isOpenTerms;
  })
  .addCase(actions.setOpenGift, (state, action) => {
    state.isOpen = action.payload.isOpen;
  })
  .addCase(actions.cashLoadData, (state, action) => {
    if (state.cash.meta.amount === action.payload.amount) {
      return;
    }
    state.cash.meta.isLoading = true;
  })
  .addCase(actions.cashSetData, (state, action) => {
    const list: ICashItem[] = [];
    const listMap: Record<number, number> = {};
    const categories: ICategoryItem[] = [];
    const categoriesMap: Record<string, boolean> = {};
    action.payload.data.forEach((item, key) => {
      list.push(item);
      listMap[item.id] = list.length - 1;
      item.categories.split(/\s*,\s*/).forEach((category) => {
        if (category in categoriesMap) {
          return;
        }
        categoriesMap[category] = true;
      });
    });
    Object.keys(categoriesMap).sort(sortByAlphabetical).forEach((category) => {
      categories.push({
        value: category,
        label: category || 'Without category',
      });
    });
    state.cash.list = list;
    state.cash.listMap = listMap;
    state.cash.categories = categories;
    state.cash.meta.isLoading = false;
    state.cash.meta.amount = action.payload.amount;
  })
  .addCase(actions.cashSelectCard, (state, action) => {
    state.cash.meta.isChanging = true;
  })
  .addCase(actions.cashChanging, (state, action) => {
    state.cash.meta.isChanging = action.payload.value;
  }));
